import { LightMode, Nightlight, Person, Schedule } from "@mui/icons-material";
import {
  Box,
  Button,
  FormControl,
  MenuItem,
  Select,
  Tab,
  Tabs,
  Typography,
} from "@mui/material";
import { LocalizationProvider, DateCalendar } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { ISearchFilter } from "../models";
import { selectFilter, searchStoreActions } from "../saga/searchStoreSlice";
import { useState } from "react";
import { Dayjs } from "dayjs";
import { generateTimeOptions } from "helpers/generateTimeOptions";
import { useNavigate } from "react-router-dom";

export function CalendarDrawer({ handleClose }: { handleClose: () => void }) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const filter = useAppSelector(selectFilter);

  const [date, setDate] = useState<Dayjs | null | undefined>(filter.date);
  const [time, setTime] = useState<string | null | undefined>(
    filter.time ?? "19:00"
  );
  const [customerNumber, setCustomerNumber] = useState<
    number | null | undefined
  >(filter.people ?? 2);
  const [tabValue, setTabValue] = useState(0);

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
  };

  const generateNumberOpts = () => {
    const options = [];

    for (let i = 1; i <= 99; i++) {
      const option = `${i}名`;
      options.push(
        <MenuItem key={option} value={i}>
          {option}
        </MenuItem>
      );
    }
    return options;
  };

  const handleSearch = () => {
    const newFilter: ISearchFilter = {
      ...filter,
      people: customerNumber,
      date: date,
      time: time,
    };
    dispatch(searchStoreActions.setSearchFilter(newFilter));
    handleClose();
    navigate("/stores");
  };

  return (
    <Box
      sx={{
        overflowY: "auto",
        py: "16px",
        position: "relative",
      }}
    >
      <Box display="flex" alignItems="center" px="16px" marginBottom="10px">
        <Box display="flex" alignItems="center" flex={1}>
          <Person color="primary" fontSize="small" sx={{ m: 1 }} />
          <Typography>人数</Typography>
        </Box>
        <FormControl size="small" sx={{ minWidth: "100px" }}>
          <Select
            placeholder="Min"
            value={customerNumber}
            onChange={(e) => setCustomerNumber(Number(e.target.value))}
            fullWidth
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 200,
                },
              },
            }}
          >
            {generateNumberOpts()}
          </Select>
        </FormControl>
      </Box>

      <Tabs
        style={{ height: "38px", minHeight: "38px" }}
        value={tabValue}
        onChange={handleTabChange}
        variant="fullWidth"
      >
        <Tab
          style={{ height: "30px", minHeight: "30px" }}
          icon={<Nightlight />}
          iconPosition="start"
          label="ディナー"
        />
        <Tab
          style={{ height: "30px", minHeight: "30px" }}
          icon={<LightMode />}
          iconPosition="start"
          label="ランチ"
        />
      </Tabs>

      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ja">
        <DateCalendar value={date} disablePast onChange={(e) => setDate(e)} />
      </LocalizationProvider>
      <Box
        display="flex"
        alignItems="center"
        p="16px"
        borderTop={1}
        borderColor="divider"
        marginBottom="30px"
      >
        <Box display="flex" alignItems="center" flex={1}>
          <Schedule color="primary" fontSize="small" sx={{ m: 1 }} />
          <Typography>時間</Typography>
        </Box>
        <FormControl size="small" sx={{ minWidth: "100px" }}>
          <Select
            placeholder="Min"
            value={time}
            fullWidth
            onChange={(e) => setTime(e.target.value)}
            MenuProps={{
              PaperProps: {
                style: {
                  maxHeight: 200,
                },
              },
            }}
          >
            <MenuItem value="指定なし">指定なし</MenuItem>
            {generateTimeOptions(7, 24)}
          </Select>
        </FormControl>
      </Box>

      <Box
        position="absolute"
        bottom={2}
        right={0}
        left={0}
        display="flex"
        justifyContent="center"
        p={2}
      >
        <Button variant="contained" onClick={handleSearch}>
          決定
        </Button>
      </Box>
    </Box>
  );
}
